export var ParseError;
(function (ParseError) {
    let Type;
    (function (Type) {
        Type["Empty"] = "EMPTY";
        Type["SyntaxError"] = "SYNTAX_ERROR";
    })(Type = ParseError.Type || (ParseError.Type = {}));
    function make(err) {
        return new SyntaxError(err);
    }
    ParseError.make = make;
    class Empty extends Error {
        constructor() {
            super();
            this.type = "EMPTY";
            this.name = 'Empty';
        }
    }
    ParseError.Empty = Empty;
    class SyntaxError extends Error {
        constructor(error) {
            super(error.message);
            this.error = error;
            this.type = "SYNTAX_ERROR";
            this.name = 'SyntaxError';
            this.location = error.location;
            this.message = error.message;
        }
    }
    ParseError.SyntaxError = SyntaxError;
})(ParseError || (ParseError = {}));
